module.exports = __webpack_public_path__ + "static/media/img3.cfc10d89.jpg";